import type { ClientListItem } from '@/entities/client';
import { useSheetStore } from '@/shared/stores/sheet-store';

// A plain function rather than a hook so it matches `onSelectClient`'s signature exactly and the
// pages can pass it straight through, with no per-page wrapper around three identical calls.
export function openClientDetailsSheet(client: ClientListItem) {
    useSheetStore.getState().openSheet({
        type: 'clients/details',
        label: client.name,
        data: { id: client.id, name: client.name },
    });
}
